import BaseModel from '../base';
import Event from '../event';

import constants from './constants';
import glossary from './glossary';

export default class RatingEvent extends BaseModel {
  constructor(item = {}, url = '') {
    super(item, url);

    this.event_id = item.event_id;
    this.koef = item.koef;
    this.ratings = item.ratings;
    this.region_id = item.region_id;

    this.event = new Event(item.event || {});
  }

  get displayRatings() {
    return this.ratings.map((item) => ({
      ...item,
      data: {
        ...RatingEvent.glossary.RATING_STATUS_DATA[item.status],
        isNew: item.status === RatingEvent.constants.RATING_STATUS.NEW,
        isConfirm: item.status === RatingEvent.constants.RATING_STATUS.CONFIRM,
        isRejected: item.status === RatingEvent.constants.RATING_STATUS.REJECTED,
      },
    }));
  }

  static get constants() {
    return constants;
  }

  static get glossary() {
    return glossary;
  }
}
